<mat-dialog-content>
    <div class="container">
        <div class="header">
            <div class="header-icon" (click)="closeDialog()"><img src="/assets/track-dialog-tick.svg" alt="tick-image" ></div>
            <div class="header-text">Nivedan has been
                created successfully!</div>

             <span class="td-highlight-text" cdkCopyToClipboard="{{data.nivedanCode}}" matTooltip="{{toolTip}}">
            {{ data.nivedanCode }}
          </span>
        </div>
        <div class="hinttxt">Do you want to create new nivedan? or make changes on the existing nivedan</div>
        <div class="btn-track"><button class="create-btn" (click)="onCreateNew()">
            create new 
          </button><button class="existing-btn" (click)="onCreateExisting()">
            make existing
          </button></div>
    </div>
    <div class="close-icon-wrapper" (click)="closeDialog()">
        <img src="/assets/cross-white.svg" alt="close-icon">
    </div>
</mat-dialog-content>
<app-spinner [loader]="loader"></app-spinner>
